import { render, staticRenderFns } from "./invoice-desc.vue?vue&type=template&id=2f4e0b4f"
import script from "./invoice-desc.vue?vue&type=script&lang=js"
export * from "./invoice-desc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports